'use client'

import { ButtonInspirational } from '@fukku/button/Inspirational/ButtonInspirational'
import type { DialogAPI } from '@fukku/dialog/Dialog'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { StoreLocatorModal } from 'maps/components/StoreLocatorModal/StoreLocatorModal'
import { useRef } from 'react'
import styles from '../NavigationLinkItem.module.css'

export const StoreLocatorButton = () => {
	const { t } = useLabels()

	const storeLocatorModalRef = useRef<DialogAPI>(null)

	const onClick = () => {
		storeLocatorModalRef.current?.show()
	}

	return (
		<>
			<ButtonInspirational
				aria-label={t('storeFinder.search.stores.label')}
				className={styles.navigationLink}
				onClick={onClick}
			>
				{t('storeFinder.search.stores.label')}
			</ButtonInspirational>
			<StoreLocatorModal storeLocatorModalRef={storeLocatorModalRef} />
		</>
	)
}
